import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'postalCode',
  standalone: true,
})
export class PostalCodePipe implements PipeTransform {
  transform(value: string): string {
    if (!value || value.length !== 7) {
      return value;
    }
    return `${value.slice(0, 3)}-${value.slice(3)}`;
  }
}
